import { useState, useEffect } from "react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

const fpPromise = FingerprintJS.load({ monitoring: false });

const useFingerprint = () => {
  const [ fingerprint, setFingerprint ] = useState(null);

  useEffect(() => {
    let cancelled = false;

    fpPromise.then(fp => fp.get()).then(result => {
      if (!cancelled) { setFingerprint(result.visitorId) };
    }).catch(() => {
      if (!cancelled) { setFingerprint(null) };
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return fingerprint;
}

export default useFingerprint;

